import { ReactNode } from "react";
// form
import { FormProvider as Form, UseFormReturn } from "react-hook-form";

// ----------------------------------------------------------------------

type Props = {
	children: ReactNode;
	methods: UseFormReturn<any>;
	autocomplete?: string;
	onSubmit?: VoidFunction;
};

export default function FormProvider({ children, onSubmit, methods, autocomplete = "on" }: Props) {
	return (
		<Form {...methods}>
			<form autoComplete={autocomplete} onSubmit={onSubmit}>
				{children}
			</form>
		</Form>
	);
}
